import React, { ReactText } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from '../../theme';

type Props = {
  children: ReactText | JSX.Element | JSX.Element[];
};

const useStyles = makeStyles({
  dot: {
    backgroundColor: colors.mainBlue,
    borderRadius: '24px',
    color: colors.white,
    fontSize: '12px',
    fontWeight: 700,
    padding: '0 10px',
  },
});

const BaseDot = ({ children }: Props) => {
  const classes = useStyles();

  return <div className={classes.dot}>{children}</div>;
};

export default BaseDot;
